var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoleManagment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32 58a25.832 25.832 0 0 1-18.417-7.646 2 2 0 1 1 2.834-2.825A22 22 0 0 0 54 32a2 2 0 0 1 4 0 26.029 26.029 0 0 1-26 26ZM8 34a2 2 0 0 1-2-2 26 26 0 0 1 44.353-18.416 2 2 0 0 1-2.825 2.832A22 22 0 0 0 10 32a2 2 0 0 1-2 2Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 34a1.992 1.992 0 0 1-1.414-.586l-4-4a2 2 0 0 1 2.828-2.828l4 4A2 2 0 0 1 8 34Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 34a2 2 0 0 1-1.414-3.414l4-4a2 2 0 0 1 2.828 2.828l-4 4A1.992 1.992 0 0 1 8 34ZM60 37a1.992 1.992 0 0 1-1.414-.586l-4-4a2 2 0 0 1 2.828-2.828l4 4A2 2 0 0 1 60 37Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 37a2 2 0 0 1-1.414-3.414l4-4a2 2 0 0 1 2.828 2.828l-4 4A1.992 1.992 0 0 1 52 37ZM32 37a10 10 0 1 1 10-10 10.011 10.011 0 0 1-10 10Zm0-16a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 47a2 2 0 0 1-2-2v-4a4 4 0 0 0-4-4H27a4 4 0 0 0-4 4v4a2 2 0 0 1-4 0v-4a8.009 8.009 0 0 1 8-8h10a8.009 8.009 0 0 1 8 8v4a2 2 0 0 1-2 2Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleManagment);
export default __webpack_public_path__ + "static/media/role-managment.c3b2e1c57ff4f2d68824df501fbb48a8.svg";
export { ForwardRef as ReactComponent };